import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, map, Observable } from "rxjs";

import { isUserAdmin, isUserOwner } from "../store/authentication";
import { AppState } from "../store/store";

@Injectable({
  providedIn: "root",
})
export class AdminGuard {
  private router = inject(Router);
  private store = inject<Store<AppState>>(Store);

  canActivate(): Observable<boolean> {
    return combineLatest([
      this.store.select(isUserAdmin),
      this.store.select(isUserOwner),
    ]).pipe(
      map(([isAdmin, isOwner]) => {
        if (isAdmin || isOwner) {
          return true;
        }
        void this.router.navigate(["/history"]);
        return false;
      })
    );
  }
}
